module.exports = __webpack_public_path__ + "static/media/google-play.d15db308.png";